export function injectScript(apiKey: string, serverUrl?: string): void {
  serverUrl = serverUrl?.replace(/^https?:\/\//, "");
  try {
    (function (
      t: Window /* window */,
      r: Document /* document */,
      y: string /* tdcScope */,
      da: string /* script */,
      ta: string /* apiKey */,
      co?: HTMLScriptElement,
      ps?: HTMLElement
    ) {
      if (r.getElementById("tdc_script")) {
        return;
      }

      // Create a global function `tdcScope` that queues calls
      (t as any)[y] =
        (t as any)[y] ||
        function () {
          ((t as any)[y].q = (t as any)[y].q || []).push(arguments);
        };

      // Create a new script element
      co = r.createElement(da) as HTMLScriptElement;
      co.async = true;
      co.src = `https://cdn.trydatacops.com/?kick_key=${ta}`;
      co.id = "tdc_script";

      // Find the first existing script tag
      ps = r.getElementsByTagName(da)[0] as HTMLElement;
      ps.parentNode?.insertBefore(co, ps);
    })(window, document, "tdcScope", "script", apiKey);
    return;
  } catch (error) {
    console.error("Error injecting script:", error);
    return;
  }
}
